import styled from "styled-components";

interface IProps {
  small?: boolean;
}

const PinInputWrapper = styled.div`
  /* Base Styling */
  position: relative;
  text-align: left;
  display: inline-flex;
  box-sizing: border-box;
  ${({ small = false }: IProps) => (small ? `transform: scale(0.8);` : ``)};
`;

export default PinInputWrapper;



// WEBPACK FOOTER //
// ./src/components/common/PinInput/PinInputWrapper.tsx